import axios from '../helpers/axios'
import { logError } from '../services';
import { IGroup } from '../models';

const API_BASE_URL = '/api/documentation/document-task-group';

export const getAdminGroups = async (): Promise<IGroup[]> => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}`);
    return data;
  } catch (error) {
    logError(error, 'getAdminGroups failed'); 
    return Promise.reject(error);
  }
};

export const updateAdminGroupUsers = async (post: IGroup): Promise<any[]> => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/members`, post);
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: post
      },
      'updateAdminGroupUsers failed'
    );
    return Promise.reject(error);
  }
};
